<template>
  <div class="popup-close-button" @click="click">
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1L11 11" stroke="#64748B" stroke-linecap="round" />
      <path d="M1 11L11 1" stroke="#64748B" stroke-linecap="round" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PopupCloseButton',
  emits: ['click'],
  methods: {
    click(e) {
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-close-button {
  width: 30px;
  height: 30px;
  background: #dbe7fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  svg {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
